/**
 * setMostRecentlyUpdatedModelId
 *
 * Sets the most recently updated model ID in Redux state.
 * This is a source-agnostic domain function — consumers depend on the
 * function signature, not on where the data lives.
 *
 * Backed by the session RTK Slice.
 *
 * @see src/store/slices/sessionSlice.ts
 */
import { getStore } from '@/store/store-proxy';
import { setMostRecentlyUpdatedModelId as setModelId } from '@/store/slices/sessionSlice';
export const setMostRecentlyUpdatedModelId = (modelId) => {
    getStore().dispatch(setModelId(modelId));
};
